export default __webpack_public_path__ + "static/media/house.f6fe9c3f.svg";